import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'clsx';

import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { Text, TextType } from 'ui-components/components/text';

import { useProductDetailsContext } from '../../../use-product-details-context';
import { messages } from '../../../messages';
import Global from '../../../../../store/global-selectors';
import generalStyle from '../../../style.module.css';
import style from './locations.module.css';

type ShipFrom = {
  shipFromId: string;
  name: string;
};

type ProductActiveLocation = {
  warehouseId: string;
  warehouseName: string;
  isSelected: boolean;
};

export const ProductDetailsLocationsV3 = () => {
  const { productActiveLocations, setProductActiveLocations } = useProductDetailsContext();

  const sellerShipFroms = useSelector(Global.selectSellerShipFroms) as ShipFrom[];

  const onToggleLocation = useCallback(
    (isActive: boolean, warehouseId: string) => {
      const targetShipFrom = sellerShipFroms.find((shipFrom) => shipFrom.shipFromId === warehouseId);
      const newActiveLocation: ProductActiveLocation = {
        warehouseId,
        warehouseName: targetShipFrom?.name ?? '',
        isSelected: isActive,
      };
      const newLocations = (productActiveLocations as ProductActiveLocation[]).map((loc) =>
        loc.warehouseId === warehouseId ? newActiveLocation : loc,
      );
      setProductActiveLocations(newLocations);
    },
    [productActiveLocations, sellerShipFroms, setProductActiveLocations],
  );

  return (
    <>
      <div className={classnames(generalStyle['shipping-defaults-header-wrapper'], generalStyle.dropped)}>
        <Text
          className={generalStyle['shipping-defaults-header-text']}
          element='div'
          textType={TextType.H4}
          value={messages.productLocations}
        />
      </div>
      <div className={style['product-locations']}>
        {sellerShipFroms.map((location) => (
          <CheckboxSlider
            key={location.shipFromId}
            checkboxId={`product-location-${location.shipFromId}`}
            checked={
              (productActiveLocations as ProductActiveLocation[]).find(
                (activeLocation) => activeLocation.warehouseId === location.shipFromId,
              )?.isSelected ?? false
            }
            className={style['product-locations-checkbox']}
            labelText={location.name}
            onChange={(isActive: boolean) => onToggleLocation(isActive, location.shipFromId)}
          />
        ))}
      </div>
    </>
  );
};
